import { render, staticRenderFns } from "./Newmv.vue?vue&type=template&id=73a251bf&scoped=true&"
import script from "./Newmv.vue?vue&type=script&lang=js&"
export * from "./Newmv.vue?vue&type=script&lang=js&"
import style0 from "./Newmv.vue?vue&type=style&index=0&id=73a251bf&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73a251bf",
  null
  
)

export default component.exports